export const RouteDelimiter = '/'

export const HomePageLink = 'https://2023.igem.wiki/ulaval/'
